import {postRequest} from './crud/postRequest'
import {getRequest} from './crud/getRequest'

export const signup = (data) => {
    return postRequest({url: '/auth/signup', data: data})
}

export const login = (data) => {
    return postRequest({url: '/auth/login', data: data})
}

export const logout = () => {
    return getRequest({url: '/auth/logout'})
}

export const getUser = ({userId}) => {
    return getRequest({url: `/api/user/${userId}`})
}

